import { useEffect } from 'react';
import { gql } from '@soundxyz/gql-string';
import { useAuth } from '@context/auth/base';
import { useQuery } from '@graphql/reactQuery';
import { ArtistInfoDocument } from '@graphql/reactQuery';
import { useLogError } from './useLogError';

/*#__PURE__*/ gql(/* GraphQL */ `
  query ArtistInfo {
    authUser {
      id
      artist {
        id
        name
        soundHandle
        webappUri
        spotifyUrl
        bannerImage {
          id
          url
          key
        }
      }
    }
  }
`);

export function useAuthArtist() {
  const { authUser } = useAuth();
  const {
    data: dataArtist,
    isLoading: loading,
    refetch,
  } = useQuery(ArtistInfoDocument, {
    staleTime: 0,
  });

  const logError = useLogError();
  const authUserId = authUser?.id;

  const mismatchAuthUserId = dataArtist?.data.authUser?.id !== authUserId;

  useEffect(() => {
    if (authUserId && mismatchAuthUserId && !loading) {
      refetch().catch(error => {
        logError({ error });
      });
    }
  }, [authUserId, mismatchAuthUserId, loading, refetch, logError]);

  const authArtist = mismatchAuthUserId ? null : dataArtist?.data.authUser?.artist || null;

  const authUserArtist = mismatchAuthUserId ? null : dataArtist?.data.authUser;

  return {
    loading,
    authUser,
    authArtist,
    authArtistLoading: loading,
    authUserArtist,
  };
}
